import { NextLinkWrapper } from '@collab/atoms';

const commonVccUiConfig = {
  linkComponent: NextLinkWrapper,
};

export default commonVccUiConfig;
